import CompaniesSection from "./sections/CompaniesSection";
import CTASection from "./sections/CTASection";
import FeaturesSection from "./sections/FeaturesSection";
import HeroSection from "./sections/HeroSection";
import WhatIsSection from "./sections/WhatIsSection";
import { useLocation } from "react-router-dom";
import Meta from "../../../components/common/Meta";
import { useTranslation } from "react-i18next";

const Top = () => {
  const location = useLocation();
  const { t } = useTranslation();

  // 現在のパスに基づいてメタタグを設定
  const meta = [
    { name: "description", content: t("meta.description") },
    // en か ja 以外なら noindex を適用
    {
      name: "robots",
      content:
        location.pathname.startsWith("/en") || location.pathname.startsWith("/ja")
          ? "index, follow"
          : "noindex, nofollow",
    },
  ];

  return (
    <>
      <Meta meta={meta} />
      <HeroSection />
      <CompaniesSection />
      <WhatIsSection />
      <FeaturesSection />
      <CTASection />
    </>
  );
};

export default Top;
